import { useCases } from "../data/marketingContent";
import { SectionHeading } from "./SectionHeading";

export function UseCases() {
  return (
    <section id="use-cases" className="section-wrap section-soft">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.76fr_1.24fr] lg:items-start">
          <SectionHeading
            eyebrow="Use cases"
            title="Digital signage for every public, shared, and operational screen."
            body="PulsePanels is shaped for teams that need reliable, repeatable screen operations rather than one-off slide decks."
          />

          <div className="grid gap-4 sm:grid-cols-2">
            {useCases.map((useCase) => {
              const Icon = useCase.icon;
              return (
                <article key={useCase.title} className="use-card">
                  <span>{Icon ? <Icon size={20} /> : null}</span>
                  <div>
                    <h3>{useCase.title}</h3>
                    <p>{useCase.body}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
